import type { Locale } from '@yi/core';

export function getLocalizedPath(path: string, locale: Locale): string {
  if (locale === 'es') {
    return `/${locale}/${path}`.replace(/\/+/g, '/').replace('/es/es/', '/es/');
  }
  return path.replace(/^\/es\//, '/');
}
